"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _AcceptAs = require("./AcceptAs.styled");
var _KnockRequestListItem = require("./KnockRequestListItem.styled");
var _broadcastSourceHelper = require("../../../utils/broadcastSourceHelper/broadcastSourceHelper");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var AcceptAs = function AcceptAs(_ref) {
  var sources = _ref.sources,
    onApprove = _ref.onApprove,
    name = _ref.name,
    isCheckHidden = _ref.isCheckHidden;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    dropdownOpen = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    sourceId = _useState4[0],
    setSourceId = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    displayName = _useState6[0],
    setDisplayName = _useState6[1];
  (0, _react.useEffect)(function () {
    var defaultSource = (0, _broadcastSourceHelper.getDefaultCameraSource)(sources, name);
    if (displayName === '' && defaultSource) {
      setDisplayName(defaultSource === null || defaultSource === void 0 ? void 0 : defaultSource.title);
      setSourceId(defaultSource === null || defaultSource === void 0 ? void 0 : defaultSource._id);
    }
  }, [name, sources, displayName]);
  var toggle = function toggle() {
    return setOpen(!dropdownOpen);
  };
  var handleChange = function handleChange(e) {
    var _sources$find;
    var value = e.target.value;
    var displayName = (_sources$find = sources.find(function (source) {
      return source._id === value;
    })) === null || _sources$find === void 0 ? void 0 : _sources$find.title;
    setDisplayName(displayName);
    setSourceId(value);
  };
  var handleApprove = function handleApprove(e) {
    e.preventDefault();
    !sourceId ? onApprove() : onApprove(sourceId);
  };
  var approvalMessage = !displayName ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Approve as a new source \xA0") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Approve as", ' ', /*#__PURE__*/_react["default"].createElement(_AcceptAs.StyledName, {
    className: "dd-privacy-mask"
  }, "\xA0", displayName, "\xA0"));
  return /*#__PURE__*/_react["default"].createElement(_reactstrap.ButtonDropdown, {
    addonType: "prepend",
    isOpen: dropdownOpen,
    toggle: toggle
  }, /*#__PURE__*/_react["default"].createElement(_AcceptAs.StyledButton, {
    onClick: handleApprove,
    "data-testid": "accept-as-approve-button"
  }, !isCheckHidden && /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledFontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faCheck,
    "aria-hidden": true
  }), approvalMessage), /*#__PURE__*/_react["default"].createElement(_AcceptAs.StyledDropdownToggle, {
    "data-testid": "accept-as-toggle"
  }, /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledFontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faCaretDown,
    "aria-hidden": true
  })), /*#__PURE__*/_react["default"].createElement(_AcceptAs.StyledDropdownMenu, {
    flip: false
  }, /*#__PURE__*/_react["default"].createElement(_AcceptAs.StyledDropdownMenuItem, {
    toggle: false,
    key: "knock-source-item-create-new-source"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "create-new-source-radio-button",
    title: "Create a new source",
    onChange: handleChange
  }, /*#__PURE__*/_react["default"].createElement(_AcceptAs.StyledRadioInput, {
    "data-testid": "create-new-source-radio-button",
    type: "radio",
    name: "unassigned-source-chooser",
    value: "",
    id: "create-new-source-radio-button",
    checked: !displayName && true
  }), "Create a new source")), sources.map(function (source, index) {
    return /*#__PURE__*/_react["default"].createElement(_AcceptAs.StyledDropdownMenuItem, {
      toggle: false,
      key: "knock-source-item-".concat(index)
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "unassigned-source-".concat(index, "-radio-button"),
      title: source.title,
      onChange: handleChange
    }, /*#__PURE__*/_react["default"].createElement(_AcceptAs.StyledRadioInput, {
      "data-testid": "unassigned-source-".concat(index, "-radio-button"),
      type: "radio",
      name: "unassigned-source-chooser",
      value: source._id,
      id: "unassigned-source-".concat(index, "-radio-button"),
      checked: source._id === sourceId
    }), source.title));
  })));
};
AcceptAs.propTypes = {
  sources: _propTypes["default"].array.isRequired,
  onApprove: _propTypes["default"].func.isRequired,
  name: _propTypes["default"].string.isRequired,
  isCheckHidden: _propTypes["default"].bool
};
var _default = exports["default"] = AcceptAs;